// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-dom/src/Css.js");
var React = require("react");
var D3Force = require("d3-force");
var Belt_List = require("bs-platform/lib/js/belt_List.js");
var Belt_Array = require("bs-platform/lib/js/belt_Array.js");
var Belt_Option = require("bs-platform/lib/js/belt_Option.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Match$Blossom = require("re-blossom/src/Match.bs.js");
var Caml_primitive = require("bs-platform/lib/js/caml_primitive.js");
var Color$BlossomPlayground = require("./Color.bs.js");
var Graph$BlossomPlayground = require("./Graph.bs.js");

function ForceGraph$SvgGraph$Legend$Circle(Props) {
  var offsetY = Props.offsetY;
  var fill = Props.fill;
  var children = Props.children;
  var strokeOpt = Props.stroke;
  var stroke = strokeOpt !== undefined ? strokeOpt : Color$BlossomPlayground.selection;
  return React.createElement("g", {
              className: "graph-legend-circle",
              transform: "translate(8, " + offsetY + ")"
            }, React.createElement("circle", {
                  fill: fill,
                  r: "8",
                  stroke: stroke,
                  strokeWidth: "2"
                }), React.createElement("text", {
                  fill: Color$BlossomPlayground.foreground,
                  transform: "translate(15, 5)"
                }, children));
}

function ForceGraph$SvgGraph$Legend$Line(Props) {
  var offsetX = Props.offsetX;
  var offsetY = Props.offsetY;
  var stroke = Props.stroke;
  var children = Props.children;
  return React.createElement("g", {
              className: "graph-legend-line",
              transform: "translate(" + offsetX + ", " + offsetY + ")"
            }, React.createElement("line", {
                  stroke: stroke,
                  strokeLinecap: "round",
                  strokeWidth: "10",
                  x1: "0",
                  x2: "10",
                  y1: "0",
                  y2: "0"
                }), React.createElement("text", {
                  fill: Color$BlossomPlayground.foreground,
                  transform: "translate(20, 5)"
                }, children));
}

function ForceGraph$SvgGraph$Legend(Props) {
  var offsetX = Props.offsetX;
  var offsetY = Props.offsetY;
  var height = Props.height;
  var width = Props.width;
  return React.createElement("g", {
              className: "graph-legend",
              transform: "translate(" + offsetX + ", " + offsetY + ")"
            }, React.createElement("rect", {
                  className: "graph-legend-background",
                  height: height,
                  width: width,
                  fill: Color$BlossomPlayground.background,
                  rx: "8",
                  ry: "8",
                  stroke: Color$BlossomPlayground.foreground,
                  strokeWidth: "1",
                  x: "0",
                  y: "0"
                }), React.createElement("g", {
                  className: "graph-legend-padding",
                  transform: "translate(7, 2)"
                }, React.createElement(ForceGraph$SvgGraph$Legend$Circle, {
                      offsetY: 15,
                      fill: Color$BlossomPlayground.cyan,
                      children: "Mated vertex"
                    }), React.createElement(ForceGraph$SvgGraph$Legend$Circle, {
                      offsetY: 40,
                      fill: Color$BlossomPlayground.pink,
                      children: "Single vertex"
                    }), React.createElement(ForceGraph$SvgGraph$Legend$Line, {
                      offsetX: 5,
                      offsetY: 65,
                      stroke: Color$BlossomPlayground.green,
                      children: "Matched edge"
                    }), React.createElement(ForceGraph$SvgGraph$Legend$Line, {
                      offsetX: 5,
                      offsetY: 90,
                      stroke: Color$BlossomPlayground.comment,
                      children: "Unused edge"
                    })));
}

function ForceGraph$SvgGraph$InfoBox(Props) {
  var offsetX = Props.offsetX;
  var offsetY = Props.offsetY;
  var children = Props.children;
  return React.createElement("g", {
              className: "graph-info-box",
              fill: Color$BlossomPlayground.foreground,
              transform: "translate(" + offsetX + ", " + offsetY + ")"
            }, React.createElement("rect", {
                  className: "graph-infoBox-background",
                  height: "75",
                  width: "115",
                  fill: Color$BlossomPlayground.background,
                  rx: "8",
                  ry: "8",
                  stroke: Color$BlossomPlayground.foreground,
                  strokeWidth: "1",
                  x: "0",
                  y: "0"
                }), React.createElement("text", {
                  style: Css.style({
                        hd: Css.fontSize(Css.px(14)),
                        tl: /* [] */0
                      }),
                  x: "4",
                  y: "16"
                }, "Selection"), React.createElement("g", {
                  transform: "translate(8, 36)"
                }, children));
}

function selectionReducer(_state, action) {
  if (!action) {
    return /* NoneSelected */0;
  }
  var mate = action.mate;
  var vertex = action.vertex;
  if (mate !== undefined) {
    return {
            TAG: /* Mated */1,
            _0: vertex,
            _1: Caml_option.valFromOption(mate)
          };
  } else {
    return {
            TAG: /* Single */0,
            _0: vertex
          };
  }
}

function ForceGraph$SvgGraph(Props) {
  var height = Props.height;
  var widthInt = Props.width;
  var links = Props.links;
  var nodes = Props.nodes;
  var gutterSize = Props.gutterSize;
  var legend = Props.legend;
  var match = React.useReducer(selectionReducer, /* NoneSelected */0);
  var setSelected = match[1];
  var selected = match[0];
  var totalHeight = String(height + gutterSize | 0);
  var height$1 = String(height);
  var width = String(widthInt);
  var tmp;
  tmp = typeof selected === "number" ? null : (
      selected.TAG ? React.createElement(ForceGraph$SvgGraph$InfoBox, {
              offsetX: 128,
              offsetY: height$1,
              children: null
            }, React.createElement(ForceGraph$SvgGraph$Legend$Circle, {
                  offsetY: 0,
                  fill: Color$BlossomPlayground.cyan,
                  children: Graph$BlossomPlayground.Vertex.toString(selected._0),
                  stroke: Color$BlossomPlayground.orange
                }), React.createElement(ForceGraph$SvgGraph$Legend$Circle, {
                  offsetY: 24,
                  fill: Color$BlossomPlayground.cyan,
                  children: Graph$BlossomPlayground.Vertex.toString(selected._1),
                  stroke: Color$BlossomPlayground.purple
                })) : React.createElement(ForceGraph$SvgGraph$InfoBox, {
              offsetX: 128,
              offsetY: height$1,
              children: React.createElement(ForceGraph$SvgGraph$Legend$Circle, {
                    offsetY: 0,
                    fill: Color$BlossomPlayground.pink,
                    children: Graph$BlossomPlayground.Vertex.toString(selected._0),
                    stroke: Color$BlossomPlayground.orange
                  })
            })
    );
  return React.createElement("svg", {
              role: "img",
              style: Css.style({
                    hd: Css.fontSize(Css.px(12)),
                    tl: {
                      hd: Css.fontFamily(/* sansSerif */-718373334),
                      tl: /* [] */0
                    }
                  }),
              alt: "Network graph visualization",
              height: totalHeight,
              width: width,
              viewBox: "0 0 " + width + " " + totalHeight,
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("title", undefined, "Network graph visualization"), React.createElement("rect", {
                  className: "graph-background",
                  height: height$1,
                  width: width,
                  onTouchStart: (function (param) {
                      return setSelected(/* Unselect */0);
                    }),
                  fill: Color$BlossomPlayground.background
                }), React.createElement("g", {
                  className: "graph-links"
                }, Belt_Array.map(links, (function (param) {
                        var match = param.data;
                        var weight = match.weight;
                        var target = param.target;
                        var source = param.source;
                        return React.createElement("line", {
                                    key: Graph$BlossomPlayground.Vertex.toString(source.data.id) + ("+" + Graph$BlossomPlayground.Vertex.toString(target.data.id)),
                                    stroke: match.linkColor,
                                    strokeLinecap: "round",
                                    strokeOpacity: String(match.opacity),
                                    strokeWidth: String(Caml_primitive.caml_float_min(Caml_primitive.caml_float_max(Math.sqrt(weight), 1), 20)),
                                    x1: String(source.x),
                                    x2: String(target.x),
                                    y1: String(source.y),
                                    y2: String(target.y)
                                  }, React.createElement("title", undefined, "Weight: " + String(weight)));
                      }))), React.createElement("g", {
                  className: "graph-nodes"
                }, Belt_Array.map(nodes, (function (param) {
                        var match = param.data;
                        var mate = match.mate;
                        var id = match.id;
                        var tmp;
                        var exit = 0;
                        if (typeof selected === "number" || !Graph$BlossomPlayground.Vertex.eq(selected._0, id)) {
                          exit = 1;
                        } else {
                          tmp = Color$BlossomPlayground.orange;
                        }
                        if (exit === 1) {
                          tmp = typeof selected === "number" || !(selected.TAG && Graph$BlossomPlayground.Vertex.eq(selected._1, id)) ? Color$BlossomPlayground.selection : Color$BlossomPlayground.purple;
                        }
                        return React.createElement("g", {
                                    key: Graph$BlossomPlayground.Vertex.toString(id),
                                    onClick: (function (param) {
                                        return setSelected(/* Select */{
                                                    vertex: id,
                                                    mate: mate
                                                  });
                                      }),
                                    onMouseLeave: (function (param) {
                                        return setSelected(/* Unselect */0);
                                      }),
                                    onMouseOver: (function (param) {
                                        return setSelected(/* Select */{
                                                    vertex: id,
                                                    mate: mate
                                                  });
                                      }),
                                    onTouchStart: (function (param) {
                                        return setSelected(/* Select */{
                                                    vertex: id,
                                                    mate: mate
                                                  });
                                      })
                                  }, React.createElement("circle", {
                                        fill: match.nodeColor,
                                        r: "10",
                                        stroke: tmp,
                                        strokeWidth: "2",
                                        transform: "translate(" + param.x + ", " + param.y + ")"
                                      }, React.createElement("title", undefined, Graph$BlossomPlayground.Vertex.toString(id))));
                      }))), legend ? React.createElement(ForceGraph$SvgGraph$Legend, {
                    offsetX: widthInt - 116 | 0,
                    offsetY: height$1,
                    height: "110",
                    width: "115"
                  }) : null, tmp);
}

function ForceGraph(Props) {
  var graph = Props.graph;
  var mates = Props.mates;
  var width = Props.width;
  var height = Props.height;
  var captionOpt = Props.children;
  var styleOpt = Props.style;
  var legendOpt = Props.legend;
  var caption = captionOpt !== undefined ? Caml_option.valFromOption(captionOpt) : null;
  var style = styleOpt !== undefined ? Caml_option.valFromOption(styleOpt) : ({});
  var legend = legendOpt !== undefined ? legendOpt : true;
  var nodes = Belt_Array.map(Graph$BlossomPlayground.verticesToArray(graph), (function (id) {
          var mate = Match$Blossom.get(mates, id);
          var nodeColor = Belt_Option.isSome(mate) ? Color$BlossomPlayground.cyan : Color$BlossomPlayground.pink;
          return {
                  data: {
                    id: id,
                    nodeColor: nodeColor,
                    mate: mate
                  }
                };
        }));
  var links = Belt_List.toArray(Belt_List.map(Graph$BlossomPlayground.toList(graph), (function (param) {
              var j = param[1];
              var i = param[0];
              var mate = Match$Blossom.get(mates, i);
              var match = mate !== undefined ? (
                  Graph$BlossomPlayground.Vertex.eq(Caml_option.valFromOption(mate), j) ? [
                      Color$BlossomPlayground.green,
                      1.0
                    ] : [
                      Color$BlossomPlayground.comment,
                      0.5
                    ]
                ) : [
                  Color$BlossomPlayground.comment,
                  0.5
                ];
              return {
                      source: Graph$BlossomPlayground.Vertex.toString(i),
                      target: Graph$BlossomPlayground.Vertex.toString(j),
                      data: {
                        weight: param[2],
                        linkColor: match[0],
                        opacity: match[1]
                      }
                    };
            })));
  var charge = D3Force.forceManyBody().strength(function () {
            return -180;
          }).distanceMin(10).distanceMax((
        height < width ? height : width
      ) / 2 | 0);
  var forceLink = D3Force.forceLink(links).id(function (d) {
          return Graph$BlossomPlayground.Vertex.toString(d.data.id);
        }).distance(function (param) {
        var linkCount = links.length;
        var maxDimension = height < width ? height : width;
        return Caml_primitive.caml_int_min(Caml_primitive.caml_int_max(Math.imul(linkCount, 5), 30), maxDimension / 2 | 0);
      });
  var simulation = D3Force.forceSimulation(nodes).force("link", forceLink).force("charge", charge).force("center", D3Force.forceCenter(width / 2 | 0, height / 2 | 0)).tick(180);
  var nodes$1 = simulation.nodes();
  var links$1 = forceLink.links();
  return React.createElement("figure", {
              className: "force-graph",
              style: style
            }, React.createElement(ForceGraph$SvgGraph, {
                  height: height,
                  width: width,
                  links: links$1,
                  nodes: nodes$1,
                  gutterSize: 126,
                  legend: legend
                }), React.createElement("figcaption", {
                  className: "force-graph__caption"
                }, caption));
}

var make = ForceGraph;

exports.make = make;
/* Css Not a pure module */
